import { render, staticRenderFns } from "./ShIngredientsCard.vue?vue&type=template&id=12b74bbb&scoped=true&"
import script from "./ShIngredientsCard.vue?vue&type=script&lang=js&"
export * from "./ShIngredientsCard.vue?vue&type=script&lang=js&"
import style0 from "./ShIngredientsCard.vue?vue&type=style&index=0&id=12b74bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b74bbb",
  null
  
)

export default component.exports